import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "PopularCollectionLayoutstyle__Container",
  componentId: "sc-208b34-0"
})(["", ""], {
  "position": "relative",
  "cursor": "ew-resize"
});
export const CardContainer = styled.div.withConfig({
  displayName: "PopularCollectionLayoutstyle__CardContainer",
  componentId: "sc-208b34-1"
})(["", " &::-webkit-scrollbar{background-color:transparent;width:16px;}&::-webkit-scrollbar-track{background-color:transparent;}&::-webkit-scrollbar-thumb{background-color:#babac0;border-radius:16px;border:4px solid #fff;}&::-webkit-scrollbar-button{display:none;}"], {
  "marginTop": "1.25rem",
  "display": "flex",
  "overflowX": "scroll",
  "paddingBottom": "1.25rem"
});